import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {TmTicketDto} from "../../../../../model/dto/entity/tm-ticket.dto";

// TODO Dependency
import {DmDocumentDto} from "../../../../../../dm/model/dto/entity/dm-document.dto";


// TODO Dependency
import {DmDocumentAssignmentDto} from "../../../../../../dm/model/dto/entity/dm-document-assignment.dto";
import {DmDocumentAssignmentEuDto} from "../../../../../../dm/model/dto/entity/dm-document-assignment-eu.dto";
import {TicketObjectDto} from "../../../../../model/dto/entity/ticket-object.dto";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {DtoList} from "../../../../../../../core/shared/dto/dto.list";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {MvsObjectNavigationService} from "../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../../core/shared/service/message/mvs-message.service";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {MvsObjectNavigationEntry} from "../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {DmDocumentAssignmentService} from "../../../../../../dm/service/api/dm-document-assignment.service";
import {DmEntityStatusEnum} from "../../../../../../dm/enum/dm-entity-status.enum";
import {DmDocumentAssignmentTypeEnum} from "../../../../../../dm/enum/dm-document-assignment-type.enum";
import {ObjectTypeService} from "../../../../../../../core/cc/service/api/object-type.service";
import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";
import {firstValueFrom} from "rxjs";

@Component({
    selector: 'tm-ticket-attachment',
    templateUrl: './tm-ticket-attachment.component.html',
    styleUrls: ['./tm-ticket-attachment.component.scss'],
    standalone: false
})
export class TmTicketAttachmentComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    toggle: boolean;
    documentEuWidget: WidgetData;
    @Input() euUserDocuments: DtoList<DmDocumentAssignmentEuDto>;
    @Input() processMode: boolean = false;
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() ticketDto: TmTicketDto;
    @Input() ticketObjects: TicketObjectDto[];
    @Output() onDocumentUploaded = new EventEmitter();

    showAssignDialog: boolean = false;
    selectedDocument: DmDocumentAssignmentDto;
    ticketObjectNames: Map<string, string> = new Map();
    ticketObjectAliases: Map<number, string> = new Map();
    assignableTicketObjects: TicketObjectDto[] = [];
    // TM-1000001438: Track which specific object is being assigned (instead of global busy)
    busyTicketObjectId: number = null;

    constructor(protected navigationService: MvsObjectNavigationService,
                protected coreService: MvsCoreService,
                protected messageService: MvsMessageService,
                protected objectTypeService: ObjectTypeService) {
    }

    ngOnInit(): void {

        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {

        if (this.processMode == true) {
            this.toggle = true;
        }
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        if (this.euUserDocuments) {
            this.prepareDocumentEuWidget(this.euUserDocuments);
        }
        this.resolveTicketObjectInfo();
        this.initialized = true;
    }

    async resolveTicketObjectInfo() {
        if (!this.ticketObjects?.length) return;

        for (const ticketObject of this.ticketObjects) {
            const key = `${ticketObject.objectTypeDtoId}_${ticketObject.objectId}`;
            if (this.ticketObjectNames.has(key)) continue;

            try {
                const typeDto = await this.objectTypeService.getViaObjectId(ticketObject.objectTypeDtoId);
                const alias = typeDto.alias;
                this.ticketObjectAliases.set(ticketObject.objectTypeDtoId, alias);
                const crudService = <MvsCrudService>this.coreService.getCrudService(alias);
                const entity = await firstValueFrom(crudService.get(ticketObject.objectId));

                let name: string;
                if (entity['calculatedName']) {
                    name = entity['calculatedName'];
                } else if (entity['contractTypeDtoName']) {
                    name = entity['contractTypeDtoName'];
                } else {
                    name = entity['name'] || entity['contractNumber'] || entity['label'] || `#${ticketObject.objectId}`;
                }

                this.ticketObjectNames.set(key, name);
            } catch {
                // Don't cache failures — allow retry on next call
            }
        }

        this.assignableTicketObjects = (this.ticketObjects || []).filter(obj => {
            const alias = this.ticketObjectAliases.get(obj.objectTypeDtoId);
            return alias === 'cr.Customer' || alias === 'cm.Contract';
        });
    }

    getTicketObjectName(ticketObject: TicketObjectDto): string {
        return this.ticketObjectNames.get(`${ticketObject.objectTypeDtoId}_${ticketObject.objectId}`) || `#${ticketObject.objectId}`;
    }

    prepareDocumentEuWidget(res: DtoList) {
        this.documentEuWidget = WidgetFactory.createWidgetTransient(
            'tm.ticket.attachment.eu.document.users.basic.widget',
            "End User Documents",
            'table',
            'transient',
            'entity',
            'cr.Customer',
            res);
    }

    onObjectSelect(dto: DmDocumentAssignmentDto) {
        const documentId = dto['document.id'] ?? dto?.documentDtoId;
        const documentTypeId = dto['e.objectTypeId'] ?? dto?.documentDtoId;

        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry(
            "dm.DmDocument",
            documentId,
            'object',
            "Dokument " + documentTypeId,
            null,
            null,
            MvsObjectNavigationActionEnum.any,
            'side');

        this.navigationService.navigateTo(mvsObjectNavigationEntry, "left");

    }

    async openAssignDialog(document: DmDocumentAssignmentDto) {
        this.selectedDocument = document;
        await this.resolveTicketObjectInfo();
        this.showAssignDialog = true;
    }

    assignDocumentToObject(ticketObject: TicketObjectDto) {
        // TM-1000001438: Per-object busy tracking instead of global busy
        if (this.busyTicketObjectId) {
            return;
        }

        this.busyTicketObjectId = ticketObject.id;

        const documentId = this.selectedDocument['document.id'] || this.selectedDocument.documentDtoId;
        const dmDocumentAssignmentService = <DmDocumentAssignmentService>this.coreService.getCrudService('dm.DmDocumentAssignment');

        const dto = new DmDocumentAssignmentDto();
        dto.documentDtoId = documentId;
        dto.objectTypeDtoId = ticketObject.objectTypeDtoId;
        dto.objectId = ticketObject.objectId;
        dto.entityStatus = DmEntityStatusEnum.active;
        dto.documentAssignmentType = DmDocumentAssignmentTypeEnum.secondary;

        dmDocumentAssignmentService.create(dto).subscribe({
            next: () => {
                this.busyTicketObjectId = null;
                this.showAssignDialog = false;
                this.messageService.showSuccessMessage('Dokument', 'Dokument wurde zugewiesen');
            },
            error: () => {
                this.busyTicketObjectId = null;
                this.messageService.showErrorMessage('Dokument', 'Fehler bei der Zuweisung');
            }
        });
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        this.refreshComponent();
    }

    handleDocumentUploaded(event: DmDocumentDto) {

    }


    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

}
